import { TruckData, Delivery, User } from '../types';

export const trucks: TruckData[] = [
  {
    id: 1,
    driverId: 101,
    licensePlate: 'AB-123-CD',
    currentLocation: { lat: 48.8566, lng: 2.3522 },
    status: 'en_route',
    currentDeliveryId: 1,
    loadWeight: 5200,
  },
  {
    id: 2,
    driverId: 102,
    licensePlate: 'EF-456-GH',
    currentLocation: { lat: 48.8496, lng: 2.3700 },
    status: 'chargement',
    currentDeliveryId: 2,
    loadWeight: 4800,
  },
  {
    id: 3,
    driverId: 103,
    licensePlate: 'IJ-789-KL',
    currentLocation: { lat: 48.8600, lng: 2.3400 },
    status: 'déchargement',
    currentDeliveryId: 3,
    loadWeight: 6100,
  },
];

export const deliveries: Delivery[] = [
  {
    id: 1,
    truckId: 1,
    clientName: 'Entreprise Dupont',
    destination: { 
      address: '15 Rue de la Paix, 75002 Paris',
      lat: 48.8698, 
      lng: 2.3300
    },
    status: 'en_cours',
    estimatedArrival: new Date(Date.now() + 25 * 60000).toISOString(),
    scheduledTime: new Date(Date.now() + 30 * 60000).toISOString(),
    cargo: 'Matériaux de construction',
    contactPhone: '0612345678',
  },
  {
    id: 2,
    truckId: 2,
    clientName: 'Bâtiments Martin',
    destination: { 
      address: '8 Avenue des Champs-Élysées, 75008 Paris',
      lat: 48.8700, 
      lng: 2.3080
    },
    status: 'en_attente',
    estimatedArrival: new Date(Date.now() + 45 * 60000).toISOString(),
    scheduledTime: new Date(Date.now() + 60 * 60000).toISOString(),
    cargo: 'Béton préfabriqué',
    contactPhone: '0623456789',
  },
  {
    id: 3,
    truckId: 3,
    clientName: 'Constructions Leroy',
    destination: { 
      address: '22 Boulevard Haussmann, 75009 Paris',
      lat: 48.8730, 
      lng: 2.3400
    },
    status: 'terminée',
    estimatedArrival: new Date(Date.now() - 15 * 60000).toISOString(),
    scheduledTime: new Date(Date.now() - 30 * 60000).toISOString(),
    cargo: 'Acier et métaux',
    contactPhone: '0634567890',
  },
  {
    id: 4,
    truckId: 1,
    clientName: 'Chantier Petit',
    destination: { 
      address: '5 Rue de Rivoli, 75001 Paris',
      lat: 48.8570, 
      lng: 2.3510
    },
    status: 'planifiée',
    estimatedArrival: new Date(Date.now() + 120 * 60000).toISOString(),
    scheduledTime: new Date(Date.now() + 150 * 60000).toISOString(),
    cargo: 'Bois et matériaux d\'isolation',
    contactPhone: '0645678901',
  },
];

export const users: User[] = [
  {
    id: 101,
    name: 'Thomas Durand',
    role: 'chauffeur',
    phone: '0612345678',
    avatar: 'https://randomuser.me/api/portraits/men/1.jpg',
  },
  {
    id: 102,
    name: 'Sophie Martin',
    role: 'chauffeur',
    phone: '0623456789',
    avatar: 'https://randomuser.me/api/portraits/women/2.jpg',
  },
  {
    id: 103,
    name: 'Pierre Dubois',
    role: 'chauffeur',
    phone: '0634567890',
    avatar: 'https://randomuser.me/api/portraits/men/3.jpg',
  },
  {
    id: 201,
    name: 'Marie Lambert',
    role: 'administrateur',
    phone: '0645678901',
    avatar: 'https://randomuser.me/api/portraits/women/4.jpg',
  },
];

export const notifications = [
  {
    id: 1,
    type: 'sms_sent',
    message: 'SMS envoyé à Entreprise Dupont: Votre livraison est en route',
    timestamp: new Date(Date.now() - 15 * 60000).toISOString(),
    deliveryId: 1,
  },
  {
    id: 2,
    type: 'weight_update',
    message: 'Poids mis à jour pour la livraison #2: 4800 kg',
    timestamp: new Date(Date.now() - 30 * 60000).toISOString(),
    deliveryId: 2,
  },
  {
    id: 3,
    type: 'delivery_complete',
    message: 'Livraison #3 terminée avec succès',
    timestamp: new Date(Date.now() - 45 * 60000).toISOString(),
    deliveryId: 3,
  },
  {
    id: 4,
    type: 'delay',
    message: 'Retard prévu pour la livraison #1: +10 minutes',
    timestamp: new Date(Date.now() - 60 * 60000).toISOString(),
    deliveryId: 1,
  },
];
